import clsx from 'clsx'
import TextButton from 'LuxKit/Button/TextButton'
import { LuxKitModalBehaviourStateContext } from 'LuxKit/Modal/context/LuxKitModalBehaviourContexts'
import { StyledModalFooter } from 'LuxKit/Modal/ModalFooter'
import { stopPropagation } from 'lib/web/eventHandlerUtils'
import React, { ComponentProps, memo, PropsWithChildren, useContext } from 'react'
import styled from 'styled-components'

const EvenMoreStyledModalFooter = styled(StyledModalFooter)`
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  min-width: 0;

  &:empty {
    visibility: hidden;
    pointer-events: none;
  }
`

export type ModalFooterOnClickHandler = (e: React.MouseEvent<HTMLButtonElement>, resolve: (result?: any) => void) => void

export interface ModalFooterActionProps extends Omit<ComponentProps<typeof TextButton>, 'onClick' | 'kind' | 'variant' | 'size' | 'fit'> {
  onClick?: ModalFooterOnClickHandler
}

interface Props extends PropsWithChildren {
  ref?: React.RefObject<HTMLElement | null>
}

function OfferComparisonModalFooter({
  children,
  ref,
}: Props) {
  const modalBehaviourState = useContext(LuxKitModalBehaviourStateContext)

  return <EvenMoreStyledModalFooter
    className={clsx({
      'has-shadow': !(modalBehaviourState?.bodyHasReachedEnd ?? true),
    })}
    onClick={stopPropagation}
    ref={ref}
  >
    {children}
  </EvenMoreStyledModalFooter>
}

export default memo(OfferComparisonModalFooter)
